<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container">
        <bread></bread>
      </div>
      <div class="container">
        <SeqTopSearch
          :orderNos.sync="orderNos"
          :tabList="tabList"
          :useInfo="useInfo"
          lastBtnText="生成订单信息"
          @upload="handleUploadFile"
          @start="handleStart"
          @clear="clearTableData"
        />
        <template v-if="this.hotSettings.data.length">
          <div class="flex flex-justify-end flex-align-center mb10 mt10">
            <el-button
              type="primary"
              @click="startAnalysis()"
              class="download-btn"
            >
              开始分析
            </el-button>
            <el-button
              type="primary"
              @click="handleDownload()"
              class="download-btn"
            >
              <span class="icon_file_box download_file_white"></span> 下载报告 
            </el-button>
          </div>
          <div class="sample-table">
            <div class="col-header">
              <span
                v-for="(item, index) in tableHeader"
                :key="index"
                :style="{
                  width: hotSettings.colWidths[index],
                  'line-height': '30px',
                }"
              >
                <template v-if="item.data === 'checkbox'">
                  <input type="checkbox" @click="checkboxOnclick($event)" />
                </template>
                <template v-else>
                  {{ item.label }}
                  <i v-if="item.required" style="color: red">*</i>
                </template>
              </span>
            </div>
            <hot-table
              ref="hotTable"
              :settings="hotSettings"
              class="hot-table"
              :licenseKey="licenseKey"
            ></hot-table>
            <div class="table-none" v-show="hotSettings.data.length === 0">
              暂无数据
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>
<script>
import _ from "lodash"
import bread from "@/components/bread";
import SeqTopSearch from "./component/SeqTopSearch";
import { showLoading, hideLoading } from "@/views/user/children/loading";
import { fixedPositionByCode, fixedPositionAnalysis, fixedPositionDownload, fixedPositionByFile } from "@/services/api.tools";
import { HotTable } from "@handsontable-pro/vue";
import "handsontable-pro/dist/handsontable.full.css";
export default {
  components: { bread, SeqTopSearch, HotTable },
  data() {
    const _this = this;
    return {
      orderNos: "",
      tableData: [],
      uploadFilePath: "",
      tabList: [
        {
          label: "订单号维度",
          name: "order",
        },
        {
          label: "ab1峰图维度",
          name: "ab1",
        },
      ],
      useInfo:{
        list: [
          "使用说明：",
          "1、数据格式：需处理的数据为.ab1峰图或峰图压缩包（只支持.zip）或多个ab1。",
          "2、ab1命名：即“样品_引物_订单号_孔号.ab1”。注：“_”为一条下划线。",
          "3、软件拼接准确率为99%以上，拼接结果比对过程中，若发现个别碱基有问题，请以原始峰图为准。",
          "4、使用详情，请点击：文档指南或视频指南。",
          "5、如有异常，请发送具体问题到对应邮箱：Cloud_Tool_Problem@tsingke.com.cn",
        ]
      },
      buttonList: [
        {
          label: "seq格式",
          value: "seq",
        },
        {
          label: "txt格式",
          value: "txt",
        },
        {
          label: "fasta格式（分）",
          value: "fasta-part",
        },
        {
          label: "fasta格式（总）",
          value: "fasta-total",
        },
      ],
      selectionList: [],
      tableHeader: [
        {
          data: "checkbox",
        },
        {
          label: "订单编号",
          data: "orderCode",
        },
        {
          label: "样品名",
          data: "simpleName",
        },
        {
          label: "引物名",
          data: "primerName",
        },
        {
          label: "预期序列",
          data: "expSeq",
          required: true,
        },
        {
          label: "检测结果",
          data: "checkResult",
        },
        {
          label: "变异类型",
          data: "variantType",
        },
        {
          label: "备注",
          data: "remark",
        },
      ],
      licenseKey: "4d522-5237a-55f42-6653a-d1494",
      hotSettings: {
        data: [],
        // 定义表结构
        colHeaders: false, //自定义列表头or 布尔值
        fillHandle: "vertical",
        columns: [
          { type: "checkbox", data: "checkbox" }, // data后面跟的这个字段是上传对应的字段
          {
            data: "orderCode",
            readOnly: true,
          },
          {
            data: "demoName",
            readOnly: true,
          },
          {
            data: "primerName",
            readOnly: true,
          },
          {
            data: "expSeq",
            validator(val, callback) {
              console.log(_this.regexp)
              const regex = _this.regexp.regATCG;
              if (Array.from(val).length > 500 || !regex.test(val))
                return callback(false);
              return callback(true);
            },
          },
          {
            data: "checkResult",
            readOnly: true,
          },
          {
            data: "variantType",
            readOnly: true,
          },
          {
            data: "remark",
            validator(val, callback) {
              if (Array.from(val).length > 50) return callback(false);
              return callback(true);
            },
          },
        ],
        minRows: 0, // 最小行列
        minCols: 0,
        maxRows: 500, // maxRows: 500,
        height: 430,
        autoWrapRow: true, // 自动换行
        colWidths: ["4%", "20%", "12%", "12%", "20%", "11%", "11%", "10%"],
        stretchH: "all",
        startRows: 0,
        afterChange: function (changes, source) {
          let data = this.getSourceData();
          function holeChange(change) {
            data.length &&
              data.forEach((v, index) => {
                if (change[0] === index && change[1] === "checkbox") {
                  v.checkbox = change[3];
                }
                if (change[1] === "expSeq") {
                  v.expSeq = _this.baseMethods.halfWidthAndUpperCaseChar(v.expSeq);
                }
              });
          }
          if (changes) {
            //复制黏贴改变
            changes.filter((v, index) => {
              holeChange(v);
            });

            data.forEach((v, index) => {
              _this.$set(_this.hotSettings.data, index, v);
            });
            this.loadData(data);
          }
        },
        afterValidate: function (isValid, value, row, prop, source) {
          if (!isValid) {
            console.log("afterValidate", value, prop);
            if (prop === "expSeq") {
              if (!value) {
                _this.lastError = "预期序列为必填项";
              } else if (Array.from(value).length <= 500) {
                _this.lastError = "预期序列必须由ATCG字符组成";
              } else if (Array.from(value).length > 300) {
                _this.lastError = "预期序列最多输入500个字";
              }
            }
            if (prop === "remark") {
              _this.lastError = "备注最多输入50个字";
            }
            _this.$message.error(_this.lastError);
          }
        },
        beforeChange: function () {
          console.info("before change", _this.hotSettings.data);
          _this.tableData = _this.hotSettings.data;
        },
        afterOnCellCornerMouseDown: function () {
          _this.hotSettings.maxRows = _this.hotSettings.data.length;
        },
      },
      single: {
        id: "",
        checkbox: false,
        orderCode: "",
        demoName: "",
        primerName: "",
        expSeq: "",
        checkResult: "",
        variantType: "",
        remark: "",
      },
      prefixName: "SNP分析文件",
      lastError: "",
      reqId: "" //下载唯一标识
    };
  },
  mounted() {
    this.orderNos = this.$route.params.nos
      ? this.$route.params.nos.join(";")
      : "";
    console.log(this.orderNos);
  },
  methods: {
    setTableHeight(rows) {
      if (rows === 0) {
        this.hotSettings.height = 0;
      } else {
        this.hotSettings.height = 430;
      }
    },
    async handleUploadFile(file, callback) {
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await fixedPositionByFile(file)
        if(res){
          const { list, reqId } = res.data
          this.hotSettings.data = list.map((item)=>{
            return _.merge({ ...this.single }, item)
          });
          this.reqId = reqId;
          this.$message.success("分析完成");
          callback(true)
        }
      } finally {
        hideLoading();
      }
    },
    async handleStart() {
      this.hotSettings.data = [];
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await fixedPositionByCode({orderCode: this.orderNos})
        if(res.status === 200){
          const { list, reqId } = res.data
          this.hotSettings.data = list.map((item)=>{
            return _.merge({ ...this.single }, item)
          });
          this.reqId = reqId;
          this.$message.success("分析完成");
        }
      } finally {
        hideLoading();
      } 
    },
    clearTableData() {
      this.hotSettings.data = [];
      this.reqId = "";
    },
    // 全选
    checkboxOnclick(evt) {
      this.hotSettings.data.forEach((v) => (v.checkbox = evt.target.checked));
    },
    // 开始分析
    async startAnalysis() {
      let validRes = await this.validateHotTable();
      if(!validRes) return
      let queryData = this.hotSettings.data.filter((item)=>{
        if(item.expSeq){
          return {
            id: item.id,
            remark: item.remark,
            expSeq: item.expSeq
          }
        }
      })
      if(!queryData.length) return this.$message.warning("至少填写一行预期序列");
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
       
        let res = await fixedPositionAnalysis(this.reqId, queryData)
        if(res.status === 200){
          const { list, reqId } = res.data
          this.hotSettings.data = list.map((item)=>{
            return _.merge({ ...this.single }, item)
          });
          this.reqId = reqId;
          this.$message.success("分析完成");
        }
      } finally {
        hideLoading();
      } 

    },
    // 下载按钮
    async handleDownload() {
      let bool = this.hotSettings.data.some((v) => v.checkbox);
      if (!bool) {
        return this.$message.warning("请选择数据");
      }
      // 判定：选中数据不存在报告，操作失败，toast提示：选中数据暂无报告
      let validRes = await this.validateHotTable();
      if(!validRes) return
      const idList = this.hotSettings.data.filter((item) => {
        if(item.expSeq){
          return {
            id: item.id,
            remark: item.remark,
            expSeq: item.expSeq
          }
        }    
      })
      if(!idList.length) return this.$message.warning("至少填写一行预期序列");
      showLoading({ text: "文件下载中，请耐心等待！" });
      try {
        
        let res = await fixedPositionDownload(this.reqId, idList)
        if(res.data){
          this.baseMethods.downloadFile(
            res.data,
            `${this.prefixName}${this.baseMethods.dateToString()}`,
            "zip"
          );
        }
      } catch(err) {
        const fileReader = new FileReader()
        fileReader.readAsText(err,'utf-8')
        fileReader.onload = ()=>{
          const result = JSON.parse(fileReader.result)
          console.log("catch", result)
          this.$message.error(result.title);
        }
      } finally {
        hideLoading();
      }
    },
    async validateHotTable() {
      const hotRef = this.$refs.hotTable.hotInstance;
      const valid = await new Promise((resolve) => {
        hotRef.validateCells((valid) => {
          resolve(valid); 
        });
      });
      if (valid) {
        return valid
      } else {
        let bool = this.hotSettings.data.some((v) => !v.sequence);
        this.$message.error(bool ? "预期序列格式有误" : this.lastError);
        return false
      }
    },
  },
};
</script>
<style scoped lang="scss">
.breads {
  overflow: auto;
  line-height: 48px;
}
.table-btn {
  padding: 0px;
}
.icon_file_box{
  width: 15px;
  height: 15px;
  margin-right: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/tools/seqSNPAnalysis.vue